import * as Sentry from "@sentry/react"
import { initializeThemePreference, ThemePreferenceProvider } from "@takt/web-ui/theme"
import { QueryClientProvider } from "@tanstack/react-query"
import { createRouter, RouterProvider } from "@tanstack/react-router"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { Toaster } from "sonner"
import { queryClient } from "@/app/query-client"
import { initializeSentry } from "@/app/sentry"
import { adminThemePreferenceAdapter } from "@/app/theme"
import { routeTree } from "@/routeTree.gen"
import "@/app.css"

initializeSentry()
initializeThemePreference()

const router = createRouter({ routeTree, defaultPreload: "intent" })

declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router
    }
}

const container = document.getElementById("app")
if (!container) throw new Error("Missing application root")

createRoot(container).render(
    <StrictMode>
        <Sentry.ErrorBoundary
            fallback={
                <p className="p-8" role="alert">
                    Groomio Admin could not load. Refresh and try again.
                </p>
            }
        >
            <QueryClientProvider client={queryClient}>
                <ThemePreferenceProvider adapter={adminThemePreferenceAdapter}>
                    <RouterProvider router={router} />
                </ThemePreferenceProvider>
                <Toaster richColors position="bottom-right" />
            </QueryClientProvider>
        </Sentry.ErrorBoundary>
    </StrictMode>,
)
